<fs-badge
  [size]="10"
  [color]="'#F30000'">
</fs-badge>